import { render } from "./SvgSprite.vue?vue&type=template&id=75714116&ts=true"
import script from "./SvgSprite.vue?vue&type=script&lang=ts"
export * from "./SvgSprite.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.17_vue@3.5.17_webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__